import { render } from "./Products.vue?vue&type=template&id=b5c27702"
import script from "./Products.vue?vue&type=script&lang=ts"
export * from "./Products.vue?vue&type=script&lang=ts"
script.render = render

export default script